<template>
  <q-page padding>
    <PageHeader
      title="Transferência Externa"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div class="row col-12 q-mt-md items-center text-brand-5 text-weight-bold">
      <div class="col-md-2 col-xs-12">
        <div class="titulo-input">Tipo Transferência</div>
        <q-select
          class="input"
          behavior="menu"
          :options="optionsTipoTransferencia"
          v-model="tipoTransferencia"
          dense
          outlined
        />
      </div>
      <div
        :class="
          tipoTransferencia.value === 'fornecedorDestino'
            ? 'col-md-3 col-xs-5 q-ml-sm sem-margin margin-top'
            : 'col-md-2 col-xs-5 q-ml-sm sem-margin margin-top'
        "
      >
        <div
          v-if="
            tipoTransferencia.value === 'origemDestino' ||
            tipoTransferencia.value === 'origemFornecedor'
          "
          class="col-md col-xs"
        >
          <div class="row items-center titulo-input">Unidade Origem</div>
          <SelecaoUnidade
            @enviarUnidade="receberUnidadeOrigem"
            :resetar="resetarUnidade"
          />
        </div>
        <div v-if="tipoTransferencia.value === 'fornecedorDestino'">
          <div class="row items-center titulo-input">Fornecedor Origem</div>
          <SelecaoFornecedor
            @enviarFornecedor="receberFornecedorOrigem"
            :resetar="resetarUnidade"
            :unidadeId="dados.destino?.id"
            :obrigatorioUnidadeId="true"
            :desabilitado="dados.destino.nome != ''"
          />
        </div>
      </div>
      <div
        :class="
          tipoTransferencia.value === 'origemFornecedor'
            ? 'col-md-3 col-xs-6 q-ml-sm margin-top'
            : 'col-md-2 col-xs-6 q-ml-sm margin-top'
        "
      >
        <div
          v-if="
            tipoTransferencia.value === 'origemDestino' ||
            tipoTransferencia.value === 'fornecedorDestino'
          "
        >
          <div class="row items-center titulo-input">Unidade Destino</div>
          <SelecaoUnidade
            @enviarUnidade="receberUnidadeDestino"
            :resetar="resetarUnidade"
          />
        </div>
        <div v-if="tipoTransferencia.value === 'origemFornecedor'">
          <div class="row items-center titulo-input">Fornecedor Destino</div>

          <SelecaoFornecedor
            @enviarFornecedor="receberFornecedorDestino"
            :resetar="resetarUnidade"
            :unidadeId="dados.origem?.id"
            :obrigatorioUnidadeId="true"
            :desabilitado="dados.origem.nome != ''"
          />
        </div>
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-xs q-ml-sm btn sem-margin"
          no-caps
          label="Criar"
          icon="add"
          color="positive"
          @click="criarTransferenciaExterna()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <TabelaTransferenciaCriada
        :tipoTransferencia="'transferencia_externa'"
        :tipoTranferenciaExterna="tipoTransferencia.value"
        :atualizarTabela="atualizarTabela"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import SelecaoUnidade from "../components/SelecaoUnidade.vue";
import TabelaTransferenciaCriada from "../components/TabelaTransferenciaCriada.vue";

import SelecaoFornecedor from "../components/SelecaoFornecedor.vue";
import { useRouter } from "vue-router";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    SelecaoUnidade,
    TabelaTransferenciaCriada,
    SelecaoFornecedor,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    const tipoTransferencia = ref({
      label: "Unidade -> Fornecedor",
      value: "origemFornecedor",
    });
    const optionsTipoTransferencia = ref([
      {
        label: "Unidade -> Fornecedor",
        value: "origemFornecedor",
      },
      {
        label: "Fornecedor -> Unidade",
        value: "fornecedorDestino",
      },
    ]);
    const dados = ref({
      origem: { nome: "", id: "" },
      destino: { nome: "", id: "" },
    });
    const resetarUnidade = ref(0);
    const atualizarTabela = ref(0);

    const criarTransferenciaExterna = async () => {
      if (tipoTransferencia.value.value == "origemFornecedor") {
        if (dados.value?.origem.id === "") {
          quasar.notify({
            message: "Selecione a unidade de origem.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        if (dados.value?.destino.id === "") {
          quasar.notify({
            message: "Selecione o fornecedor de destino.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }
      if (tipoTransferencia.value.value == "fornecedorDestino") {
        if (dados.value?.origem.id === "") {
          quasar.notify({
            message: "Selecione o fornecedor de origem.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
        if (dados.value?.destino.id === "") {
          quasar.notify({
            message: "Selecione o unidade de destino.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }
      }
      try {
        const response = await store.dispatch(
          "ferramentaria/criarTransferencia",
          {
            tipo: "externa",
            unidadeIdOrigem:
              tipoTransferencia.value.value === "origemFornecedor"
                ? dados.value?.origem.id
                : undefined,
            unidadeIdDestino:
              tipoTransferencia.value.value === "origemFornecedor"
                ? undefined
                : dados.value?.destino.id,
            fornecedorIdOrigem:
              tipoTransferencia.value.value === "origemFornecedor"
                ? undefined
                : dados.value?.origem.id,
            fornecedorIdDestino:
              tipoTransferencia.value.value === "origemFornecedor"
                ? dados.value?.destino.id
                : undefined,
          }
        );
        quasar.notify({
          message: "Transferência externa criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetCampo();
        atualizarTabela.value++;
        router.push({
          name: "ferramentaria-detalhe-transferencia-externa",
          params: {
            transferenciaId: response.data.resultado.transferenciaUuid,
          },
        });
      } catch (error) {
        if (error.response.data?.erros?.mensagem) {
          quasar.notify({
            message: error.response.data?.erros?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response.data?.erro?.mensagem) {
          quasar.notify({
            message: error.response.data?.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const resetCampo = () => {
      dados.value = {
        origem: { nome: "", id: "" },
        destino: { nome: "", id: "" },
      };
      resetarUnidade.value++;
    };

    const receberUnidadeOrigem = (value) => {
      if (value === null) {
        dados.value.origem = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.origem = {
        nome: value.nome,
        id: value.id,
      };
    };

    const receberUnidadeDestino = (value) => {
      if (value === null) {
        dados.value.destino = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.destino = {
        nome: value.nome,
        id: value.id,
      };
    };

    const receberFornecedorOrigem = (value) => {
      if (value === null) {
        dados.value.origem = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.origem = {
        nome: value.nome,
        id: value.parceiroId,
      };
    };

    const receberFornecedorDestino = (value) => {
      if (value === null) {
        dados.value.destino = {
          nome: "",
          id: "",
        };
        return;
      }
      dados.value.destino = {
        nome: value.nome,
        id: value.parceiroId,
      };
    };

    watch(
      () => tipoTransferencia.value,
      () => {
        resetCampo();
      }
    );

    return {
      dados,
      receberUnidadeOrigem,
      receberUnidadeDestino,
      receberFornecedorDestino,
      receberFornecedorOrigem,
      tipoTransferencia,
      optionsTipoTransferencia,
      resetarUnidade,
      atualizarTabela,
      criarTransferenciaExterna,
    };
  },
};
</script>

<style scoped>
.icon {
  cursor: pointer;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .btn {
    font-size: 12px;
  }
  .sem-margin {
    margin-left: 0px;
  }
  .margin-top {
    margin-top: 9px;
  }
}
</style>
